export default (ordinalNumber, title) => {
  const formatedNumber = `0${ordinalNumber}`.slice(-2);
  return `${formatedNumber}. ${title}`;
};
